import React, { useEffect } from "react";
import "./placeholder.scss";

interface NoDataFoundProps {
  text: string;
}

const NoDataFound = ({ text }: NoDataFoundProps) => {
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, Math.floor(Math.random() * 100) + 150);
  }, []);

  if (isLoading) {
    return (
      <div className="placeholder-container">
        <div className="live-panel-item">
          <div className="teamContainer">
            <div className="placeholder-animation"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="placeholder-container">
      <div className="live-panel-container game-table all-schedule">
        <div className="live-panel-item">
          <div className="teamContainer">
            <p>{text}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoDataFound;
